import {
    aircraftcompletemessages,
} from "../../request/api";

/**
 * 飞机信息
 * @param aircraftCompleteMsg
 * @param customGe
 * @returns {AircraftInfo}
 */
export default function AircraftInfo(aircraftCompleteMsg) {
    var obj = aircraftCompleteMsg;

    //飞机身上属性
    this.latestTime = Date.now(); //上一次时间
    this.icao = obj.icao;
    this.sn = obj.sn;

    this.aircraftcategory = obj.aircraftcategory;
    this.airVelocityInfo = obj.airVelocityInfo;
    this.airLocationInfo = obj.airLocationInfo;
    this.obj = obj;
    this.admessage = obj.admessage;
    this.callsign = obj.callsign;
    this.devicetype = obj.devicetype;
    this.heightchange = obj.heightchange;
    this.alLongitude = null;
    this.alLatitude = null;
    this.correctLongitude = obj.airLocationInfo.alLongitude;
    this.correctLatitude = obj.airLocationInfo.alLatitude
    this.speed = obj.airVelocityInfo.avGroundSpeed;
    this.avBiasMagneticNorth = obj.airVelocityInfo.avBiasMagneticNorth;
    this.transpondercode = obj.transpondercode;

    this.currentHeight = false;
    this.alarmHeight = '';
    this.watchAir = '';
    this.dargxy = {};

    this.initPartOfGeneralCompany(obj);
    this.initDargxy();


    this.init(obj); //初始化数据

    if (this.partOfGeneralCompany) { //是否显示标牌
        this.isShowLabel = true;
    } else {
        this.isShowLabel = false;
    }

    this.showAircraftFlag = true; //是否显示飞机
    this.hasLabel = false; //是否有标牌

    this.isStation = false; //是否基站

    this.showLocus = false; //是否显示轨迹
    this.showWake = false; //是否显示尾迹
    this.isFollow = false; //是否关注
    this.showPredictLine = false; //是否预计线


    //是否在告警中
    this.alarmShow = false;

    //是否鼠标点击(距离测量中使用)
    this.isMouseOn = false;

    if (obj.callsign) {
        this.callsign = obj.callsign;
        if (obj.callsign == "THISCAR") {
            this.isStation = true;
        }
    }

}


AircraftInfo.prototype.initPartOfGeneralCompany = function(obj) {
    this.partOfGeneralCompany = obj.partOfGeneralCompany;
    if (obj.partOfGeneralCompany) {} else {
        ourMap.$vm.localIcaoArr.forEach((item) => {
            if (obj.icao === item.AACode.toLowerCase()) {
                this.partOfGeneralCompany = true;
                this.icon = item.icon;
                this.devicetype = item.devicetype;
                this.company = item.company
            }
        });
    }
};





AircraftInfo.prototype.init = function(obj) { //变化的值
    this.obj = obj;
    this.airVelocityInfo = obj.airVelocityInfo;
    this.airLocationInfo = obj.airLocationInfo;
    this.heightchange = obj.heightchange;
    this.alLongitude = obj.airLocationInfo.alLongitude;
    this.alLatitude = obj.airLocationInfo.alLatitude;
    this.correctLongitude = obj.airLocationInfo.alLongitude;
    this.correctLatitude = obj.airLocationInfo.alLatitude;
    this.speed = obj.airVelocityInfo.avGroundSpeed;
    this.avBiasMagneticNorth = obj.airVelocityInfo.avBiasMagneticNorth;
    this.transpondercode = obj.transpondercode;

    if (obj.callsign) {
        this.callsign = obj.callsign;
        if (obj.callsign == "THISCAR") {
            this.isStation = true;
        }
    }

}

/**
 * 初始化标牌位置
 * @params N
 */

AircraftInfo.prototype.initDargxy = function(N = 1, aircraftInfos) {
    var aircraftInfo = this;

    let a = (2 * Math.PI) * Math.random(); //角度
    const R = 50 * N; //半径

    let x = Math.round(R * Math.cos(a) - 0);
    let y = Math.round(R * Math.sin(a) - 0);


    aircraftInfo.dargxy.x = x;
    aircraftInfo.dargxy.y = y;

    if (aircraftInfos) {
        let aircraftsInfo = aircraftInfos[aircraftInfo.getAircraftInfoIndex(aircraftInfo.icao, aircraftInfos)]
        aircraftsInfo.dargxy = aircraftInfo.dargxy;
    }

}

AircraftInfo.prototype.getAircraftInfoIndex = function(icao, aircraftInfos) {

    for (var i = 0; i < aircraftInfos.length; i++) {
        var aircraftInfo = aircraftInfos[i];
        if (aircraftInfo.icao == icao) {
            return i;
        }
    }
    return -1;

}


/**
 * 标牌避让
 * @params aircraftInfos
 */
AircraftInfo.prototype.dargxyCollision = function(aircraftInfos) {

    var aircraftInfo = this;

    let currentDargxy = ourMap.getInitDargxy(aircraftInfo, aircraftInfo.dargxy); //当前圆心坐标

    let R = 35; //半径
    if (!aircraftInfo.currentHeight) {
        return
    }
    if (!aircraftInfo.partOfGeneralCompany) {
        return
    }

    // 获取所有飞机标牌位置
    let aircraftInfoArr = []

    aircraftInfos.forEach((i) => {
        if (!(Number(i.airLocationInfo.geometricHeight) >= aircraftInfo.alarmHeight[0] && Number(i.airLocationInfo.geometricHeight) <= aircraftInfo.alarmHeight[1])) {
            return
        }
        if (i.isStation) {
            return
        }
        if (aircraftInfo.icao == i.icao) { return }
        if (!i.partOfGeneralCompany) {
            return
        }
        aircraftInfoArr.push(i);

    });

    function serializeDargxy(aircraftInfoArr, num) {

        let flag = false;

        for (let i = 0; i < 360; i++) {
            let flagU = 0;
            aircraftInfo.initDargxy(num, aircraftInfos);
            currentDargxy = ourMap.getInitDargxy(aircraftInfo, aircraftInfo.dargxy);
            aircraftInfoArr.forEach((aircraftInfoI) => {
                let aircraftInfoIDargxy = ourMap.getInitDargxy(aircraftInfoI, aircraftInfoI.dargxy);

                if (Math.sqrt(Math.pow(Math.abs(currentDargxy.x - aircraftInfoIDargxy.x), 2) + Math.pow(Math.abs(currentDargxy.y - aircraftInfoIDargxy.y), 2)) < 2 * R) {
                    // if (Math.abs(currentDargxy.x - aircraftInfoIDargxy.x) < 2 * R && Math.abs(currentDargxy.y - aircraftInfoIDargxy.y) < 2 * R) { //有碰撞 
                    flag = false;
                } else {
                    flagU++
                }

            })

            if (aircraftInfoArr.length == 0) {
                flag = true;
                break
            }

            //都没有碰撞终止，有一次碰撞就进入下一次循环。
            if (flagU == aircraftInfoArr.length) {
                flag = true;
                break
            }

        }
        return flag;
    }

    let flag;
    for (let index = 0; index < 10; index++) {
        flag = serializeDargxy(aircraftInfoArr, 2);
        if (flag) {
            break
        }
    }

    if (!flag) { //全碰撞
        for (let index = 0; index < 10; index++) {
            let flag = serializeDargxy(aircraftInfoArr, 2.5);
            if (flag) {
                break
            }
        }
    }
    if (!flag) { //全碰撞
        for (let index = 0; index < 10; index++) {
            let flag = serializeDargxy(aircraftInfoArr, 3);
            if (flag) {
                break
            }
        }
    }
    if (!flag) { //全碰撞
        for (let index = 0; index < 10; index++) {
            let flag = serializeDargxy(aircraftInfoArr, 3.5);
            if (flag) {
                break
            }


        }
    }

}


/**
 * 飞机从GE上消失
 */
AircraftInfo.prototype.disappear = function() {

    var aircraftInfo = this;
    ourMap.removeOldMarkerByIcao(aircraftInfo.icao);

}


/**
 * 标牌从GE上消失
 * @param icao
 */
AircraftInfo.prototype.disappearLabel = function(icao) {

    var aircraftInfo = this;
    ourMap.removeOldLabelByIcao(icao);

}

/**
 * 飞机在GE上展示
 */
AircraftInfo.prototype.appear = function() {

    var aircraftInfo = this;

    //是否为地面站
    if (aircraftInfo.isStation) {
        if (ourMap.getOneKeyGroundBaseIndex(aircraftInfo.icao) != -1) {
            // ourMap.createOneStation(aircraftInfo);
        }
    } else {
        ourMap.createOneMarker(aircraftInfo);

        if (aircraftInfo.isShowLabel) {
            if (!aircraftInfo.currentHeight) {
                return
            }
            aircraftInfo.hasLabel = true;
            ourMap.createAircraftLabel(aircraftInfo);
        }

    }
}

/**
 * 定位
 */
AircraftInfo.prototype.locate = function() {
    var aircraftInfo = this;
    ourMap.setVersion(aircraftInfo.correctLongitude, aircraftInfo.correctLatitude, false);
}

/**
 * 改变飞机位置
 */
AircraftInfo.prototype.changeLocation = function() {

    var aircraftInfo = this;
    var marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);

    let Angle = aircraftInfo.aircraftcategory === 'FREE_BALLOON' ? 0 : Number(aircraftInfo.airVelocityInfo.avBiasMagneticNorth);

    if (marker) {
        marker.setLatLng(
                L.latLng(
                    aircraftInfo.alLatitude,
                    aircraftInfo.alLongitude
                )
            )
            .setRotationAngle(Angle);

    }
}


/**
 * 飞机赋予最新信息
 * @param aircraftCompleteMsg
 */
AircraftInfo.prototype.setNewValue = function(aircraftCompleteMsg) {

    var aircraftInfo = this;

    var obj = aircraftCompleteMsg;
    aircraftInfo.latestTime = new Date().getTime();

    this.init(obj)
}


/**
 * 设置标牌
 */
AircraftInfo.prototype.setAircraftLabel = function() {
    var aircraftInfo = this;

    let latlon = ourMap.fixed(aircraftInfo, aircraftInfo.dargxy);

    let polyline = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
    let marketDiv = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);

    if (polyline) {
        let latlng = ourMap.correctOffsetDargxy(aircraftInfo);
        polyline.setLatLngs([
            [
                aircraftInfo.alLatitude,
                aircraftInfo.alLongitude,
            ],
            latlng,
        ]);

    }

    if (marketDiv) {
        marketDiv.setLatLng(latlon);

        if (marketDiv._icon) {
            marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(aircraftInfo, marketDiv);
        }

    }

}

/**
 * 绘制轨迹
 * @param icao
 */
AircraftInfo.prototype.showDrawAdsbLocus = async function(icao) {

    var aircraftInfo = this;
    aircraftInfo.showLocus = true;

    var index = ourMap.getOneLocusLinePolyIndex(aircraftInfo);

    if (index == -1) {
        let res = await aircraftcompletemessages({ sn: icao });
        let data = [];
        res.forEach((item) => {
            let itemArr = [];
            itemArr[0] = item.allatitude - 0;
            itemArr[1] = item.allongitude - 0;
            data.unshift(itemArr);
        });
        data.unshift([aircraftInfo.alLatitude,
            aircraftInfo.alLongitude,
        ]);
        var poly = ourMap.createLocusLine(aircraftInfo.icao, data);
        ourMap.locusLinePolys.push(poly);
    }
}


/**
 * 绘制轨迹小程序
 * @param icao
 */

AircraftInfo.prototype.showDrawWatchAdsbLocus = async function(icao) {

    var aircraftInfo = this;
    aircraftInfo.showLocus = true;

    var index = ourMap.getOneLocusLinePolyIndex(aircraftInfo);

    if (index == -1) {

        let data = [];

        data.unshift([aircraftInfo.alLatitude,
            aircraftInfo.alLongitude,
        ]);
        var poly = ourMap.createLocusLine(aircraftInfo.icao, data);
        ourMap.locusLinePolys.push(poly);
    }
}


/**
 * 轨迹随飞机移动而增加
 */
AircraftInfo.prototype.addLocus = function() {
    var aircraftInfo = this;


    var index = ourMap.getOneLocusLinePolyIndex(aircraftInfo);
    if (index != -1) {

        var hotlineLayer = ourMap.locusLinePolys[index];
        var data = ourMap.locusLinePolys[index].getLatLngs();
        data.unshift([
            aircraftInfo.alLatitude,
            aircraftInfo.alLongitude,
        ]);
        hotlineLayer.setLatLngs(data);
    }
}

/**
 * 删除轨迹
 */
AircraftInfo.prototype.hideLocus = function() {
    var aircraftInfo = this;
    aircraftInfo.showLocus = false;

    var index = ourMap.getOneLocusLinePolyIndex(aircraftInfo);
    console.log(index);
    if (index != -1) {
        ourMap.adsbMap.locusGroup.removeLayer(ourMap.locusLinePolys[index]);
        ourMap.locusLinePolys.splice(index, 1);
    }
}




/**
 * 绘制尾迹
 * @param icao
 */
AircraftInfo.prototype.showDrawAdsbWake = async function(icao) {

    var aircraftInfo = this;
    aircraftInfo.showWake = true;

    var index = ourMap.getOneWakeLinePolyIndex(aircraftInfo);

    if (index == -1) {
        let res = await aircraftcompletemessages({ sn: aircraftInfo.sn });
        let data = [];
        for (var i = 0; i <= 50; i++) {
            data.unshift([res[i].allatitude - 0, res[i].allongitude - 0]);
        }

        data.unshift([aircraftInfo.alLatitude,
            aircraftInfo.alLongitude,
        ]);
        var poly = ourMap.createWakeLine(aircraftInfo.icao, data);
        ourMap.wakeLinePolys.push(poly);
    }
}

/**
 * 尾迹随飞机移动而增加
 */
AircraftInfo.prototype.addWake = function() {
    var aircraftInfo = this;

    var index = ourMap.getOneWakeLinePolyIndex(aircraftInfo);
    if (index != -1) {

        var hotlineLayer = ourMap.wakeLinePolys[index];
        var data = hotlineLayer.getLatLngs();
        data.unshift([
            aircraftInfo.alLatitude,
            aircraftInfo.alLongitude,
        ]);
        hotlineLayer.setLatLngs(data);
    }
}

/**
 * 删除尾迹
 */
AircraftInfo.prototype.hideWake = function() {
    var aircraftInfo = this;
    aircraftInfo.showWake = false;

    var index = ourMap.getOneWakeLinePolyIndex(aircraftInfo);
    if (index != -1) {
        ourMap.adsbMap.wakeGroup.removeLayer(ourMap.wakeLinePolys[index]);
        ourMap.wakeLinePolys.splice(index, 1);
    }
}



/**
 * 创建关注
 */
AircraftInfo.prototype.showFollow = function() {
    var aircraftInfo = this;
    aircraftInfo.isFollow = true;
    map.flyTo([aircraftInfo.alLatitude, aircraftInfo.alLongitude], 13);

    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
    let icon = ourMap.getMarkerFollowIcon(aircraftInfo);
    marker.setIcon(icon);

    // var index = ourMap.getOneFollowPolyIndex(aircraftInfo);
    // if (index == -1) {

    //     let poly = ourMap.createFollow(aircraftInfo.icao, [aircraftInfo.alLatitude, aircraftInfo.alLongitude]);

    //     ourMap.followPolys.push(poly);
    // }
}

/**
 * 移动关注
 */
AircraftInfo.prototype.addFollow = function() {
    var aircraftInfo = this;
    map.setView([aircraftInfo.alLatitude, aircraftInfo.alLongitude]);

    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
    let icon = ourMap.getMarkerFollowIcon(aircraftInfo);
    marker.setIcon(icon);


    // var index = ourMap.getOneFollowPolyIndex(aircraftInfo);
    // if (index != -1) {
    //     var layer = ourMap.followPolys[index];
    //     layer.setLatLng([aircraftInfo.alLatitude, aircraftInfo.alLongitude])
    //     console.log(layer);
    // }
}

/**
 * 删除关注
 */
AircraftInfo.prototype.hideFollow = function() {
    var aircraftInfo = this;
    aircraftInfo.isFollow = false;
    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);

    let icon = ourMap.getMarkerIcon(aircraftInfo);

    if (marker) {
        marker.setIcon(icon);
    }

    // var index = ourMap.getOneFollowPolyIndex(aircraftInfo);
    // if (index != -1) {
    //     ourMap.adsbMap.followGroup.removeLayer(ourMap.followPolys[index]);
    //     ourMap.followPolys.splice(index, 1);
    // }
}



/**
 * 显示飞机预计线
 */
AircraftInfo.prototype.showDarwPredictLine = function() {
    var aircraftInfo = this;

    aircraftInfo.hidePredictLine();

    aircraftInfo.showPredictLine = true;
    ourMap.createPredictLine(aircraftInfo);
}



/**
 * 隐藏飞机预计线
 */
AircraftInfo.prototype.hidePredictLine = function() {
    var aircraftInfo = this;
    aircraftInfo.showPredictLine = false;

    var index = ourMap.getOnePredictLinePolyIndex(aircraftInfo);
    if (index != -1) {
        var predictLinePoly = ourMap.predictLinePolys[index];
        map.removeLayer(predictLinePoly);
        ourMap.predictLinePolys.splice(index, 1);
    }

}


/**
 * 计算飞机预计线末坐标
 */
AircraftInfo.prototype.getPredictLine = function() {
    var endLaAndLo = {};
    var aircraftInfo = this;
    var la_start = aircraftInfo.correctLatitude;
    var lo_start = aircraftInfo.correctLongitude;
    var biasMagneticNorth = aircraftInfo.avBiasMagneticNorth;
    var speed = aircraftInfo.speed;
    var modulus_la = 111;
    var modulus_lo = 111 * Math.cos(2 * Math.PI / 360 * la_start);
    var k = 1.852 / 60;
    var t = 3; //3分钟
    var speed_la;
    var speed_lo;
    var realBiasMagneticNorth;
    if (biasMagneticNorth <= 90) {
        realBiasMagneticNorth = 2 * Math.PI / 360 * biasMagneticNorth;
        speed_la = speed * Math.cos(realBiasMagneticNorth);
        speed_lo = speed * Math.sin(realBiasMagneticNorth);
        endLaAndLo.la = la_start * 1 + speed_la * k * t / modulus_la;
        endLaAndLo.lo = lo_start * 1 + speed_lo * k * t / modulus_lo;

    } else if (biasMagneticNorth > 90 && biasMagneticNorth <= 180) {
        realBiasMagneticNorth = 2 * Math.PI / 360 * (biasMagneticNorth - 90);
        speed_la = speed * Math.sin(realBiasMagneticNorth);
        speed_lo = speed * Math.cos(realBiasMagneticNorth);
        endLaAndLo.la = la_start * 1 - speed_la * k * t / modulus_la;
        endLaAndLo.lo = lo_start * 1 + speed_lo * k * t / modulus_lo;

    } else if (biasMagneticNorth > 180 && biasMagneticNorth <= 270) {
        realBiasMagneticNorth = 2 * Math.PI / 360 * (biasMagneticNorth - 180);
        speed_la = speed * Math.cos(realBiasMagneticNorth);
        speed_lo = speed * Math.sin(realBiasMagneticNorth);
        endLaAndLo.la = la_start * 1 - speed_la * k * t / modulus_la;
        endLaAndLo.lo = lo_start * 1 - speed_lo * k * t / modulus_lo;

    } else {
        realBiasMagneticNorth = 2 * Math.PI / 360 * (biasMagneticNorth - 270);
        speed_la = speed * Math.sin(realBiasMagneticNorth);
        speed_lo = speed * Math.cos(realBiasMagneticNorth);
        endLaAndLo.la = la_start * 1 + speed_la * k * t / modulus_la;
        endLaAndLo.lo = lo_start * 1 - speed_lo * k * t / modulus_lo;
    }
    return endLaAndLo;
}


AircraftInfo.prototype.hideAircraft = function() {
    var aircraftInfo = this;
    aircraftInfo.showAircraftFlag = false;
    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
    let polyline = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
    let marketDiv = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);


    marker.setOpacity(0);
    if (marketDiv) {
        marketDiv.setOpacity(0);
    }

    if (polyline) {
        polyline.setStyle({
            opacity: 0,
            fillOpacity: 0,
        });
    }

}

AircraftInfo.prototype.showAircraft = function() {
    var aircraftInfo = this;
    aircraftInfo.showAircraftFlag = true;
    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
    let polyline = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
    let marketDiv = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
    marker.setOpacity(1);
    if (marketDiv) {
        marketDiv.setOpacity(1);
    }
    if (polyline) {
        polyline.setStyle({
            opacity: 1,
            fillOpacity: 1,
        });
    }

}

AircraftInfo.prototype.showStation = function() {
    var aircraftInfo = this;
    let marker = ourMap.getOneKeyStationIndex(aircraftInfo.icao);

    if (marker != -1) {
        marker.setOpacity(1);
    }
}

AircraftInfo.prototype.hideStation = function() {
    var aircraftInfo = this;
    let marker = ourMap.getOneKeyStationIndex(aircraftInfo.icao);

    if (marker != -1) {
        marker.setOpacity(0);
    }
}